









import { defineComponent, PropType } from '@vue/composition-api'
import { Page } from '../models/page-viewmodel'
import LinkDirective from '@/shared/directives/link-directive'

export default defineComponent({
    name: 'PageComponent',
    props: {
        item: {
            type: Object as PropType<Page>,
            required: true
        }
    },
    directives: {
        LinkDirective
    }
})
